module.exports = __webpack_public_path__ + "img/me.977c9a00.png";